import { createUseStyles } from 'react-jss';
import color from 'color';

import { ThemeProps } from '@styles/theme';
import { flex, textOverflowDots } from '@resources/mixins';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    expanded: {},
    notActive: {},
    mainWrapper:{
        height: '100%',
        padding: theme.spacing(8),
        [theme.down('desktop')]: {
            padding: theme.spacing(5),
        },
        [theme.down('mobile')]: {
            height: 'auto',
            padding: 0,
        },
    },
    body: {
        display: 'flex',
        padding: `${theme.spacing(4)} 0 ${theme.spacing(4)} ${theme.spacing(11.5)}`,
    },

    header: {
        color: theme.colors.grey_text,
        fontSize: 17,
        fontFamily: theme.font.secondary,
        lineHeight: 1.25,
        paddingBottom: 10,
        [theme.down('mobile')]: {
            fontSize: 14,
            paddingBottom: theme.spacing(1),
        },
    },
    subheader: {
        color: theme.colors.grey_text,
        fontSize: 16,
        fontFamily: theme.font.secondary,
        lineHeight: 1.25,
        paddingBottom: 10,
        [theme.down('mobile')]: {
            fontSize: 13,
            paddingBottom: theme.spacing(0.5),
        },
    },
    title: {
        [theme.down('mobile')]: {
            display: 'none',
        },
        fontFamily: theme.font.secondary,
        fontWeight: 'normal',
        fontSize: 20,
        padding: '10px 0',
        textAlign: 'center',
        color: theme.colors.grey_text,
        border: `solid ${theme.colors.grey_light}`,
        borderWidth: '0 1.5px 1.5px 1.5px',
        background: theme.colors.white,
        width: '100%',
        height: '5%',
    },

    emailWrapper: {
        width: 443,
    },

    groupsWrapper: {
        width: 304,
    },

    text: {
        color: theme.colors.black,
        lineHeight: 1.5,
        fontSize: 16,
        fontFamily: theme.font.primary,
        overflowWrap: 'anywhere',
        [theme.down('tablet')]: {
            fontSize: 14,
        },
        [theme.down('mobile')]: {
            fontSize: 13,
        },
    },

    expandIcon: {
        transformOrigin: 'center',
        transition: 'transform .2s ease',
        transform: 'rotate(90deg)',

        '&$expanded': {
            transform: 'rotate(-90deg)',
        },
    },

    button: {
        border: 'none',
        background: 'none',
        outline: 'none',
        padding: 0,
        minHeight: 40,
        minWidth: 40,
        ...flex('row', 'center', 'center'),

        '&:disabled': {
            opacity: .3,
        },

        '&:hover': {
            background: theme.colors.icon_background,
            borderRadius: theme.radius / 2,
            cursor: 'pointer',
        },
    },

    buttonCreate: {
        width: 'auto',
        height: 'auto',
        fontFamily: theme.font.secondary,
        fontSize: 20,
        lineHeight: 1.4,
        fontWeight: 'normal',
        padding: '10px 8px',
        borderRadius: theme.radius / 2,
        background: theme.colors.icon_background,
        color: theme.colors.violet_primary,
        '&:hover': {
            background: theme.colors.transp_violet,
        },
    },

    marginLeft: {
        marginLeft: 10,
    },

    buttonTakeover: {
        width: 26,
        height: 26,
    },

    actionIcon: {
        width: 26,
        height: 26,
    },

    userWrapper: {
        ...flex('row', 'flex-start', 'center'),
    },

    userAvatar: {
        display: 'inline-flex',
        marginRight: theme.spacing(3),
        [theme.down('desktop')]: {
            display: 'none',
        },
    },

    tableActionsContainer: {
        height: '10%',
        alignContent: 'center',
        [theme.down('mobile')]: {
            height: 'auto',
            padding: `0 0 ${theme.spacing(3)}px`,
        },
    },
    tableActions: {
        ...flex('row', 'space-between', 'center'),
        padding: `0 ${theme.spacing(4)}`,
        [theme.down('mobile')]: {
            flexWrap: 'wrap',
            gap: theme.spacing(2.5),
            padding: 0,
        },
    },
    tableContainer:{
        height: '85%',
        [theme.down('mobile')]: {
            height: 'auto',
        },
    },
    filters: {
        display: 'flex',
        alignItems: 'center',
        [theme.down('mobile')]: {
            width: '100%',
        },
    },
    invite: {
        display: 'flex',
        alignItems: 'center',
        [theme.down('mobile')]: {
            width: '100%',
        },
    },
    inviteButtons: {
        display: 'flex',
        alignItems: 'center',
        [theme.down('mobile')]: {
            width: '100%',
            gap: theme.spacing(2.5),

            '& button': {
                flex: '1 1 0',
                margin: 0,
                whiteSpace: 'nowrap',
            },
        },
    },
    h4: {
        fontFamily: theme.font.secondary,
        fontSize: 20,
        lineHeight: 1.4,
        fontWeight: 'normal',
        color: theme.colors.black,
    },
    addIcon: {
        color: theme.colors.violet_primary,
        cursor: 'pointer',
        marginLeft: theme.spacing(3),
    },

    filterIcon: {
        color: theme.colors.violet_primary,
        cursor: 'pointer',
    },

    searchWrapper: {
        width: '100%',
        maxWidth: 312,
        [theme.down('mobile')]: {
            maxWidth: 'none',
        },
        marginRight: -theme.spacing(4),
        [theme.down('mobile')]: {
            marginRight: 0,
        },
    },

    moreItemsPresent: {
        color: theme.colors.blue_link,
        marginLeft: theme.spacing(2),
        fontFamily: theme.font.secondary,
    },

    noInfo: {
        color: theme.colors.grey_text,
        ...textOverflowDots(),
        display: 'inherit',
    },

    userStatus: {
        padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
        borderRadius: theme.radius,
        color: theme.colors.violet_primary,
        backgroundColor: `${color(theme.colors.violet_primary).fade(0.92)}`,

        '&$notActive': {
            color: theme.colors.grey_text,
            backgroundColor: `${color(theme.colors.grey_lighter).fade(0.35)}`,
        },
    },

    capitalized: {
        textTransform: 'capitalize',
    },

    ellipsis: {
        ...textOverflowDots(),
    },
    nameWrapper: {
        ...flex('row', 'center', 'center'),
    },
    companyName: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '200px',
        whiteSpace: 'nowrap',
    },
    bodySubComponent: {
        display: 'flex',
        flexDirection: 'column',
        padding: `0 ${theme.spacing(4)} 0 ${theme.spacing(10)}`,
        [theme.down('mobile')]: {
            padding: 0,
            gap: theme.spacing(3),
        },
    },
    descriptionWrapper: {
        padding: `0 ${theme.spacing(2)} ${theme.spacing(4)} ${theme.spacing(2)}`,
        flex: '18 0 18%',
        flexDirection: 'row',
        [theme.down('mobile')]: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(2),
            padding: 0,
        },
    },
    optionWrapper: {
        width: '20%',
        display: 'inline-block',
        [theme.down('mobile')]: {
            width: '100%',
            display: 'block',
        },
    },
}));
